export default __webpack_public_path__ + "static/media/banner11.453d68cb.png";